<template>
  <b-row class="match-height">
    <b-col
      v-for="address in dataList"
      :key="address.id"
      cols="12"
      md="6"
    >
      <address-card :address="address" />
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-card no-body>
        <b-card-body
          class="d-flex align-items-center justify-content-center text-center"
        >
          <b-button
            variant="flat-primary"
            size="lg"
            class="p-5"
            @click="newAddress()"
          >
            <FeatherIcon
              icon="PlusCircleIcon"
              size="48"
            />
            <div class="font-medium-4 mt-1">
              Yeni Adres Ekle
            </div>
          </b-button>
        </b-card-body>
      </b-card>
    </b-col>
    <address-sidebar />
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BButton, VBToggle,
} from 'bootstrap-vue'
import AddressCard from '@/views/Customers/View/CustomerAddress/AddressCard.vue'
import AddressSidebar from '@/views/Customers/AddressSidebar.vue'

export default {
  name: 'CustomerAddress',
  components: {
    BRow, BCol, BCard, BCardBody, BButton, AddressCard, AddressSidebar,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  computed: {
    dataList() {
      return this.$store.getters['customerAddresses/dataList']
    },
    saveData() {
      return this.$store.getters['customerAddresses/dataSaveStatus']
    },
    dataSideBar() {
      return this.$store.getters['customerAddresses/dataSideBar']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.getData()
      } else if (val.status === false) {
        this.getData()
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    newAddress() {
      this.$store.commit('customerAddresses/SET_DATA_ITEM', {
        id: null,
        title: null,
        name: null,
        phone: null,
        email: null,
        address: null,
        id_countries: '216',
        id_cities: null,
        id_customers: this.$route.params.id,
      })
      this.dataSideBar.status = true
    },
    getData() {
      this.$store.dispatch('customerAddresses/getDataList', {
        select: [
          'customer_addresses.id AS id',
          'customer_addresses.title AS title',
          'customer_addresses.name AS name',
          'customer_addresses.phone AS phone',
          'customer_addresses.email AS email',
          'customer_addresses.address AS address',
          'countries.title AS country',
          'cities.title AS city',
          'customer_addresses.id_countries AS id_countries',
          'customer_addresses.id_cities AS id_cities',
        ],
        where: {
          'customer_addresses.id_customers': this.$route.params.id,
        },
      })
    },
  },
}
</script>
